// Talks to the WordPress REST proxy created by the Allie Chat Widget plugin.
// The OpenAI API key never touches the browser: this only ever calls our
// own site's REST endpoint, which calls OpenAI server-side.

function getConfig() {
  if (typeof window === 'undefined') return null
  return window.AllieChatConfig || null
}

export async function sendChatMessage(message, history = []) {
  const config = getConfig()

  if (!config || !config.restUrl) {
    throw new Error(
      'Allie chat is not connected yet. Ask the site admin to finish setup under Settings > Allie Chat.',
    )
  }

  const response = await fetch(config.restUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': config.nonce || '',
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      message,
      // Only send a short trailing window of history so payload/token
      // usage stays bounded; the server enforces its own cap too.
      history: history.slice(-10),
    }),
  })

  let data = null
  try {
    data = await response.json()
  } catch {
    // ignore malformed/empty body
  }

  if (!response.ok) {
    const message =
      (data && (data.message || (data.data && data.data.message))) ||
      'Allie could not respond right now.'
    throw new Error(message)
  }

  if (!data || typeof data.reply !== 'string') {
    throw new Error('Allie sent back an unexpected response.')
  }

  return data.reply
}
